import { setInputMask } from '../../../components/views/chat/actions';

const LimitInputPhoneOrService = {
    name: 'limitInputPhoneOrService',
    exec: () => {
        setInputMask('PHONE|NEO');
    }
};

export default LimitInputPhoneOrService;
